// ============================================================================
// TEGOLA VECTOR CONFIG V4
// Combines V2's backend layer structure with V3's styling.
// Single "tegola" source matching the new API at localhost:5000.
// V3 styling: Roboto fonts for places, road label color inversion at high zoom,
// zoom-interpolated shield spacing, improved boundary dash patterns.
// ============================================================================

const TEGOLA_BASE_URL = typeof process !== "undefined" && process.env.REACT_APP_TEGOLA_BASE_URL
  ? process.env.REACT_APP_TEGOLA_BASE_URL
  : "https://tegola-v2-maps-pub-int.delhivery.com/maps";
const TEGOLA_MAP = typeof process !== "undefined" && process.env.REACT_APP_TEGOLA_MAP
  ? process.env.REACT_APP_TEGOLA_MAP
  : "india";
const RAILWAY_STROKE_COLOR = "#CCC";
const RAILWAY_STROKE_WIDTH = 1.5;
const RAILWAY_MAIN_DASHARRAY = [4, 2];
const RAILWAY_MINOR_DASHARRAY = [4, 2];
const RAILWAY_MAIN_TIE_SPACING = (RAILWAY_MAIN_DASHARRAY[0] + RAILWAY_MAIN_DASHARRAY[1]) * RAILWAY_STROKE_WIDTH;
// eslint-disable-next-line no-unused-vars
const RAILWAY_MINOR_TIE_SPACING = (RAILWAY_MINOR_DASHARRAY[0] + RAILWAY_MINOR_DASHARRAY[1]) * RAILWAY_STROKE_WIDTH;
const RAILWAY_MAIN_TIE_SIZE = 8.4;
// eslint-disable-next-line no-unused-vars
const RAILWAY_MINOR_TIE_SIZE = 7.2;

// States missing or poorly placed in tile data – show as point labels
const STATE_LABELS_FALLBACK_GEOJSON = {
  type: "FeatureCollection",
  features: [
    { type: "Feature", geometry: { type: "Point", coordinates: [88.52, 27.53] }, properties: { name: "Sikkim" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [72.2, 10.0] }, properties: { name: "Lakshadweep" } },
  ],
};

// Neighbouring countries and water bodies – show as point labels
const COUNTRY_LABELS_FALLBACK_GEOJSON = {
  type: "FeatureCollection",
  features: [
    { type: "Feature", geometry: { type: "Point", coordinates: [80.7718, 7.8731] }, properties: { name: "Sri Lanka" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [69.3451, 30.3753] }, properties: { name: "Pakistan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [87.6, 31] }, properties: { name: "China" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [95.9562, 21.9162] }, properties: { name: "Myanmar" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [90.3563, 23.685] }, properties: { name: "Bangladesh" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [84.124, 28.395] }, properties: { name: "Nepal" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [90.4336, 27.5142] }, properties: { name: "Bhutan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [67.71, 33.939] }, properties: { name: "Afghanistan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [67.5, 43] }, properties: { name: "Kazakhstan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [65, 15] }, properties: { name: "Arabian Sea" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [88, 15] }, properties: { name: "Bay of Bengal" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [53.69, 32.43] }, properties: { name: "Iran" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [44.37, 33.31] }, properties: { name: "Iraq" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [45.08, 23.89] }, properties: { name: "Saudi Arabia" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [54.3, 23.6] }, properties: { name: "UAE" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [56.1, 21.5] }, properties: { name: "Oman" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [48.52, 15.55] }, properties: { name: "Yemen" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [50.55, 26.07] }, properties: { name: "Qatar" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [50.56, 25.93] }, properties: { name: "Bahrain" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [47.98, 29.31] }, properties: { name: "Kuwait" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [36.24, 34.80] }, properties: { name: "Syria" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [35.86, 33.85] }, properties: { name: "Lebanon" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [35.90, 31.95] }, properties: { name: "Jordan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [59.56, 38.97] }, properties: { name: "Turkmenistan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [64.59, 41.38] }, properties: { name: "Uzbekistan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [71.28, 38.86] }, properties: { name: "Tajikistan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [74.77, 41.20] }, properties: { name: "Kyrgyzstan" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [101.0, 15.87] }, properties: { name: "Thailand" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [102.5, 19.86] }, properties: { name: "Laos" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [108.28, 14.06] }, properties: { name: "Vietnam" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [104.99, 12.57] }, properties: { name: "Cambodia" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [101.98, 4.21] }, properties: { name: "Malaysia" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [113.92, -0.79] }, properties: { name: "Indonesia" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [121.77, 12.88] }, properties: { name: "Philippines" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [57, 7] }, properties: { name: "Indian Ocean" } },
    { type: "Feature", geometry: { type: "Point", coordinates: [115, 5] }, properties: { name: "South China Sea" } },
  ],
};


export const tegolaVectorConfig = {
  source: {
    tegola: {
      type: "vector",
      tiles: [`${TEGOLA_BASE_URL}/${TEGOLA_MAP}/{z}/{x}/{y}.pbf`],
      minzoom: 0,
      maxzoom: 20,
      scheme: "xyz",
      tolerance: 0,
    },
    state_labels_fallback: {
      type: "geojson",
      data: STATE_LABELS_FALLBACK_GEOJSON,
    },
    country_labels_fallback: {
      type: "geojson",
      data: COUNTRY_LABELS_FALLBACK_GEOJSON,
    },
  },

  layers: [
    // ========================================================================
    // LAYER 1: POLYGONS / FILLS (Bottom layer - rendered first)
    // ========================================================================

    // Asia Water Body (Z0+)
    {
      id: "asia_water_boundary",
      type: "fill",
      source: "tegola",
      "source-layer": "asia_water_boundary",
      minzoom: 0,
      maxzoom: 20,
      paint: {
        "fill-color": "#8BD8EA",
        "fill-opacity": 1
      },
    },

    // Asian Country Boundaries fill (Z0+)
    {
      id: "asia_country_boundary_fill",
      type: "fill",
      source: "tegola",
      "source-layer": "asia_country_boundary",
      minzoom: 0,
      maxzoom: 20,
      paint: {
        "fill-color": "#E8E5E5",
        "fill-opacity": [
          "interpolate", ["linear"], ["zoom"],
          0, 0.6,
          6, 0.4,
          10, 0.2
        ]
      },
    },

    // Landcover Low (Z4-10)
    {
      id: "landcover_low",
      type: "fill",
      source: "tegola",
      "source-layer": "landcover_low",
      minzoom: 4,
      maxzoom: 10,
      paint: {
        "fill-color": [
          "match", ["get", "class"],
          "wood", "#A2E0BA",
          "scrub", "#A2E0BA",
          "heath", "#A2E0BA",
          "grassland", "#A2E0BA",
          "tree_row", "#A2E0BA",
          "tundra", "#A2E0BA",
          "forest", "#A2E0BA",
          "grass", "#A2E0BA",
          "meadow", "#A2E0BA",
          "village_green", "#A2E0BA",
          "nature_reserve", "#A2E0BA",
          "protected_area", "#A2E0BA",
          "national_park", "#A2E0BA",
          // Fallback
          "#E8E5E5"
        ],
        "fill-opacity": 1
      },
    },

    // Landcover Mid (Z10-14)
    {
      id: "landcover_mid",
      type: "fill",
      source: "tegola",
      "source-layer": "landcover_mid",
      minzoom: 10,
      maxzoom: 14,
      paint: {
        "fill-color": [
          "match", ["get", "class"],
          "wood", "#A2E0BA",
          "scrub", "#A2E0BA",
          "heath", "#A2E0BA",
          "grassland", "#A2E0BA",
          "tree_row", "#A2E0BA",
          "tundra", "#A2E0BA",
          "forest", "#A2E0BA",
          "grass", "#A2E0BA",
          "meadow", "#A2E0BA",
          "village_green", "#A2E0BA",
          "nature_reserve", "#A2E0BA",
          "protected_area", "#A2E0BA",
          "national_park", "#A2E0BA",
          // Fallback
          "#E8E5E5"
        ],
        "fill-opacity": 1
      },
    },

    // Landcover High (Z14+)
    {
      id: "landcover_high",
      type: "fill",
      source: "tegola",
      "source-layer": "landcover_high",
      minzoom: 14,
      maxzoom: 20,
      paint: {
        "fill-color": [
          "match", ["get", "class"],
          "wood", "#A2E0BA",
          "scrub", "#A2E0BA",
          "heath", "#A2E0BA",
          "grassland", "#A2E0BA",
          "tree_row", "#A2E0BA",
          "tundra", "#A2E0BA",
          "forest", "#A2E0BA",
          "grass", "#A2E0BA",
          "meadow", "#A2E0BA",
          "village_green", "#A2E0BA",
          "nature_reserve", "#A2E0BA",
          "protected_area", "#A2E0BA",
          "national_park", "#A2E0BA",
          // Fallback
          "#E8E5E5"
        ],
        "fill-opacity": 1
      },
    },

    // Landuse Agricultural (Z10+)
    {
      id: "landuse_agricultural",
      type: "fill",
      source: "tegola",
      "source-layer": "landuse_agricultural",
      minzoom: 10,
      maxzoom: 20,
      paint: {
        "fill-color": "#B9F6CA",
        "fill-opacity": 1
      },
    },

    // Transport Areas (Z13+)
    {
      id: "transport_areas",
      type: "fill",
      source: "tegola",
      "source-layer": "transport_areas",
      minzoom: 13,
      maxzoom: 20,
      paint: {
        "fill-color": "#DDD6E8",
        "fill-opacity": 0.6
      },
    },


    // Landuse Developed Low (Z9-13)
    {
      id: "landuse_developed_low",
      type: "fill",
      source: "tegola",
      "source-layer": "landuse_developed_low",
      minzoom: 9,
      maxzoom: 13,
      paint: {
        "fill-color": [
          "match", ["get", "class"],
          // Urban - Light Greys / Beiges
          "residential", "#E8E5E5",
          "commercial", "#f0e3d0ff",
          "retail", "#f0e3d0ff",
          "construction", "#E8E5E5",
          "greenfield", "#E8E5E5",
          // Industrial - Dark/Cool Greys
          "industrial", "#f0e3d0ff",
          "port", "#DDD6E8",
          "depot", "#DDD6E8",
          "railway", "#DDD6E8",
          "quarry", "#8A7C75",
          "landfill", "#8A7C75",
          "brownfield", "#E8E5E5",
          // Fallback
          "#E8E5E5"
        ],
        "fill-opacity": 0.6
      },
    },

    // Landuse Developed High (Z13+)
    {
      id: "landuse_developed_high",
      type: "fill",
      source: "tegola",
      "source-layer": "landuse_developed_high",
      minzoom: 13,
      maxzoom: 20,
      paint: {
        "fill-color": [
          "match", ["get", "class"],
          // Urban - Light Greys / Beiges
          "residential", "#E8E5E5",
          "commercial", "#f0e3d0ff",
          "retail", "#f0e3d0ff",
          "construction", "#E8E5E5",
          "greenfield", "#E8E5E5",
          // Industrial - Dark/Cool Greys
          "industrial", "#f0e3d0ff",
          "port", "#DDD6E8",
          "depot", "#DDD6E8",
          "railway", "#DDD6E8",
          "quarry", "#8A7C75",
          "landfill", "#8A7C75",
          "brownfield", "#E8E5E5",
          // Fallback
          "#E8E5E5"
        ],
        "fill-opacity": 0.6
      },
    },

    // Landuse Special (Z11+)
    {
      id: "landuse_special",
      type: "fill",
      source: "tegola",
      "source-layer": "landuse_special",
      minzoom: 11,
      maxzoom: 20,
      paint: {
        "fill-color": [
          "match", ["get", "class"],
          // Institutional - Tans / Pale Oranges
          "education", "#afcddfff",
          "religious", "#f5efe6ff",
          "institutional", "#D1E1F2",
          "cemetery", "#f5efe6ff",
          "military", "#f5efe6ff",
          // Fallback
          "#E8E5E5"
        ],
        "fill-opacity": 0.5
      },
    },

    // Leisure (Z11+)
    {
      id: "leisure",
      type: "fill",
      source: "tegola",
      "source-layer": "leisure",
      minzoom: 11,
      maxzoom: 20,
      paint: {
        "fill-color": "#BBECCF",
        "fill-opacity": 1
      },
    },

    // Water Polygon Low (Z3-8)
    {
      id: "water_polygon_low",
      type: "fill",
      source: "tegola",
      "source-layer": "water_polygon_low",
      minzoom: 3,
      maxzoom: 8,
      paint: {
        "fill-color": "#8BD8EA",
        "fill-opacity": 1
      },
    },

    // Water Polygon Mid (Z8-13)
    {
      id: "water_polygon_mid",
      type: "fill",
      source: "tegola",
      "source-layer": "water_polygon_mid",
      minzoom: 8,
      maxzoom: 13,
      paint: {
        "fill-color": "#8BD8EA",
        "fill-opacity": 1
      },
    },

    // Water Polygon High (Z13+)
    {
      id: "water_polygon_high",
      type: "fill",
      source: "tegola",
      "source-layer": "water_polygon_high",
      minzoom: 13,
      maxzoom: 20,
      paint: {
        "fill-color": "#8BD8EA",
        "fill-opacity": 1
      },
    },

    // Buildings (Z15+) - V3 styling: later appearance
    {
      id: "buildings",
      type: "fill",
      source: "tegola",
      "source-layer": "buildings",
      minzoom: 15,
      maxzoom: 20,
      paint: {
        "fill-color": "#E7E8EB",
        "fill-opacity": 1
      },
    },

    // Buildings outline (Z15+)
    {
      id: "buildings_outline",
      type: "line",
      source: "tegola",
      "source-layer": "buildings",
      minzoom: 15,
      maxzoom: 20,
      paint: {
        "line-color": "#BEC0C4",
        "line-width": 0.5,
        "line-opacity": 1
      },
    },

    // Aeroway Polygon (Z9+)
    {
      id: "aeroway_polygon",
      type: "fill",
      source: "tegola",
      "source-layer": "aeroway_polygon",
      minzoom: 9,
      maxzoom: 20,
      paint: {
        "fill-color": "#DDD6E8",
        "fill-opacity": 0.8
      },
    },

    // Aeroway Heli Polygon (Z9+)
    {
      id: "aeroway_heli_polygon",
      type: "fill",
      source: "tegola",
      "source-layer": "aeroway_heli_polygon",
      minzoom: 9,
      maxzoom: 20,
      paint: {
        "fill-color": "#DDD6E8",
        "fill-opacity": 0.8
      },
    },



    // ========================================================================
    // LAYER 2: LINES (Roads, waterways, boundaries)
    // ========================================================================

    // Water Line Major (Z9-13)
    {
      id: "water_line_major",
      type: "line",
      source: "tegola",
      "source-layer": "water_line_major",
      minzoom: 9,
      maxzoom: 13,
      layout: {
        "line-cap": "round",
        "line-join": "round",
        "line-miter-limit": 2,
        "line-round-limit": 1.05
      },
      paint: {
        "line-color": "#8BD8EA",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          6, 1,
          12, 2
        ]
      },
    },

    // Water Line Minor (Z13+)
    {
      id: "water_line_minor",
      type: "line",
      source: "tegola",
      "source-layer": "water_line_minor",
      minzoom: 13,
      maxzoom: 20,
      layout: {
        "line-cap": "round",
        "line-join": "round",
        "line-miter-limit": 2,
        "line-round-limit": 1.05
      },
      paint: {
        "line-color": "#8BD8EA",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          13, 0.5,
          14, 1.5,
          18, 3
        ]
      },
    },

    // Railways (Z11+) - V3 styling: earlier appearance
    {
      id: "railways",
      type: "line",
      source: "tegola",
      "source-layer": "railways",
      minzoom: 11,
      maxzoom: 20,
      layout: {
        "line-cap": "butt",
        "line-join": "round"
      },
      paint: {
        "line-color": RAILWAY_STROKE_COLOR,
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          0, RAILWAY_STROKE_WIDTH,
          17.5, RAILWAY_STROKE_WIDTH,
          20, 3
        ]
      },
    },
    {
      id: "railways_ties",
      type: "symbol",
      source: "tegola",
      "source-layer": "railways",
      minzoom: 14,
      maxzoom: 20,
      filter: [">=", ["zoom"], 14],
      layout: {
        "text-field": "|",
        "text-font": ["Roboto Medium"],
        "text-size": [
          "interpolate", ["linear"], ["zoom"],
          0, RAILWAY_MAIN_TIE_SIZE,
          18, RAILWAY_MAIN_TIE_SIZE,
          20, RAILWAY_MAIN_TIE_SIZE * 2
        ],
        "symbol-placement": "line",
        "text-rotation-alignment": "map",
        "text-rotate": 0,
        "symbol-spacing": RAILWAY_MAIN_TIE_SPACING,
        "text-allow-overlap": true,
        "text-ignore-placement": true
      },
      paint: {
        "text-color": RAILWAY_STROKE_COLOR,
        "text-translate": [-1, 2.5],
        "text-translate-anchor": "map"
      },
    },

    // Aeroway Line (Z9+)
    {
      id: "aeroway_line",
      type: "line",
      source: "tegola",
      "source-layer": "aeroway_line",
      minzoom: 9,
      maxzoom: 20,
      layout: {
        "line-cap": "round",
        "line-join": "round"
      },
      paint: {
        "line-color": "#c0b8d0",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          11, 1,
          16, 8
        ]
      },
    },

    // ========================================================================
    // ROADS - Casings (drawn first for outline effect)
    // V3 styling applied to V2 layer names
    // ========================================================================

    // ========================================================================
    // ROADS - Casings (drawn first for outline effect)
    // Render order (bottom→top): Path→Service→Residential→TertiaryLink→Tertiary→SecondaryLink→Secondary→PrimaryLink→Primary→MW/TrunkLink→MW/Trunk
    // ========================================================================

    // Roads Path - Casing (Z16+) – lowest priority
    {
      id: "roads_path_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_path",
      minzoom: 16,
      maxzoom: 20,
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": ["step", ["zoom"], "rgba(0, 0, 0, 0)", 18, "#A5BACB"],
        "line-width": 5,
        "line-dasharray": [2, 2],
        "line-opacity": ["step", ["zoom"], 0, 18, 1]
      },
    },

    // Roads Path - Dashed (Z16+)
    {
      id: "roads_path",
      type: "line",
      source: "tegola",
      "source-layer": "roads_path",
      minzoom: 16,
      maxzoom: 20,
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": ["step", ["zoom"], "rgba(0, 0, 0, 0)", 18, "#F0F0F0"],
        "line-width": 5,
        "line-dasharray": [2, 2],
        "line-opacity": ["step", ["zoom"], 0, 18, 1]
      },
    },

    // Roads Service - Casing (Z17+)
    {
      id: "roads_service_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_service",
      minzoom: 17,
      maxzoom: 20,
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#A5B3C2",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          17, 2.25, 18, 6.5, 19, 24, 20, 24
        ]
      },
    },

    // Roads Minor (Residential class) - Casing (Z14+)
    {
      id: "roads_minor_residential_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_minor",
      minzoom: 14,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "residential"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#97A5B5",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          14, 0.26, 15, 1.1, 16, 2.1, 17, 2.5, 18, 14, 19, 37, 20, 37
        ]
      },
    },

    // Roads Minor (Tertiary Link) - Casing (Z14+)
    {
      id: "roads_minor_tertiary_link_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_minor",
      minzoom: 14,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "tertiary_link"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#8D9BAA",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          14, 0.26, 15, 1.1, 16, 2.1, 17, 2.5, 18, 14, 19, 37, 20, 37
        ]
      },
    },

    // Roads Minor (Tertiary class) - Casing (Z12+)
    {
      id: "roads_minor_tertiary_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_minor",
      minzoom: 12,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "tertiary"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#8D9BAA",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          12, 0.51, 13, 1.1, 14, 2.5, 15, 4, 16, 5, 17, 7, 18, 18, 19, 42, 20, 42
        ]
      },
    },

    // Roads Secondary Link - Casing (Z14+)
    {
      id: "roads_secondary_link_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_secondary",
      minzoom: 14,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "secondary_link"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#8D9BAA",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          14, 0.26, 15, 1.1, 16, 2.1, 17, 2.5, 18, 14, 19, 37, 20, 37
        ],
        "line-blur": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.7, 14, 0.45, 18, 0.15, 20, 0
        ],
        "line-opacity": [
          "interpolate", ["linear"], ["zoom"],
          7, 1
        ]
      },
    },

    // Roads Secondary - Casing (Z7+)
    {
      id: "roads_secondary_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_secondary",
      minzoom: 7,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "secondary"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#8D9BAA",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          7, 0.51, 8, 0.51, 9, 0.51, 10, 1.5, 11, 1.5, 12, 2.5, 13, 2.5, 14, 5, 15, 7, 16, 10, 17, 12, 18, 22, 19, 52, 20, 52
        ],
        "line-blur": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.7, 14, 0.45, 18, 0.15, 20, 0
        ],
        "line-opacity": [
          "interpolate", ["linear"], ["zoom"],
          7, 1
        ]
      },
    },

    // Roads Primary Link - Casing (Z12+)
    {
      id: "roads_primary_link_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_primary",
      minzoom: 12,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "primary_link"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#8D9BAA",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          12, 0.51, 13, 1.1, 14, 2.5, 15, 4, 16, 5, 17, 7, 18, 18, 19, 42, 20, 42
        ],
        "line-blur": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.7, 14, 0.45, 18, 0.15, 20, 0
        ],
        "line-opacity": [
          "interpolate", ["linear"], ["zoom"],
          7, 1
        ]
      },
    },

    // Roads Primary - Casing (Z7+)
    {
      id: "roads_primary_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_primary",
      minzoom: 7,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "primary"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#8D9BAA",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          7, 0.51, 8, 0.51, 9, 0.51, 10, 1.5, 11, 1.5, 12, 2.5, 13, 2.5, 14, 5, 15, 7, 16, 10, 17, 12, 18, 22, 19, 52, 20, 52
        ],
        "line-blur": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.7, 14, 0.45, 18, 0.15, 20, 0
        ],
        "line-opacity": [
          "interpolate", ["linear"], ["zoom"],
          7, 1
        ]
      },
    },

    // Roads Motorway/Trunk Link - Casing (Z7+)
    {
      id: "roads_mw_trunk_link_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_motorway",
      minzoom: 7,
      maxzoom: 20,
      filter: ["any",
        ["==", ["get", "class"], "motorway_link"],
        ["==", ["get", "class"], "trunk_link"]
      ],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#6D8297",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          7, 0.51, 8, 0.51, 9, 0.51, 10, 1.5, 11, 1.5, 12, 2.5, 13, 2.5, 14, 5, 15, 7, 16, 10, 17, 12, 18, 22, 19, 52, 20, 52
        ],
        "line-opacity": 1
      },
    },

    // Roads Motorway/Trunk - Casing (Z5+)
    {
      id: "roads_motorway_casing",
      type: "line",
      source: "tegola",
      "source-layer": "roads_motorway",
      minzoom: 5,
      maxzoom: 20,
      filter: ["any",
        ["==", ["get", "class"], "motorway"],
        ["==", ["get", "class"], "trunk"]
      ],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#6D8297",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          5, 0.26, 6, 0.51, 7, 1.1, 8, 1.1, 9, 2.1, 10, 2.1, 11, 6, 12, 6, 13, 6, 14, 12, 15, 14, 16, 16, 17, 22, 18, 32, 19, 72, 20, 72
        ],
        "line-opacity": 1
      },
    },

    // ========================================================================
    // ROADS - Center lines (drawn on top of casings)
    // Same render order: Path→Service→Residential→TertiaryLink→Tertiary→SecondaryLink→Secondary→PrimaryLink→Primary→MW/TrunkLink→MW/Trunk
    // ========================================================================

    // Roads Service - Center (Z17+)
    {
      id: "roads_service",
      type: "line",
      source: "tegola",
      "source-layer": "roads_service",
      minzoom: 17,
      maxzoom: 20,
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#BCC9D7",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          17, 2, 18, 6, 19, 22, 20, 22
        ]
      },
    },

    // Roads Minor (Residential class) - Center (Z14+)
    {
      id: "roads_minor_residential",
      type: "line",
      source: "tegola",
      "source-layer": "roads_minor",
      minzoom: 14,
      maxzoom: 20,
      filter: ["!=", ["get", "class"], "tertiary"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#A9B8C8",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          14, 0.25, 15, 1, 16, 2, 17, 2, 18, 12, 19, 35, 20, 35
        ]
      },
    },

    // Roads Minor (Tertiary Link) - Center (Z14+)
    {
      id: "roads_minor_tertiary_link",
      type: "line",
      source: "tegola",
      "source-layer": "roads_minor",
      minzoom: 14,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "tertiary_link"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#A9B8C8",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          14, 0.25, 15, 1, 16, 2, 17, 2, 18, 12, 19, 35, 20, 35
        ]
      },
    },

    // Roads Minor (Tertiary class) - Center (Z12+)
    {
      id: "roads_minor_tertiary",
      type: "line",
      source: "tegola",
      "source-layer": "roads_minor",
      minzoom: 12,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "tertiary"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#A9B8C8",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          12, 0.5, 13, 1, 14, 2, 15, 3, 16, 4, 17, 6, 18, 16, 19, 40, 20, 40
        ]
      },
    },

    // Roads Secondary Link - Center (Z14+)
    {
      id: "roads_secondary_link",
      type: "line",
      source: "tegola",
      "source-layer": "roads_secondary",
      minzoom: 14,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "secondary_link"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#A9B8C8",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          14, 0.25, 15, 1, 16, 2, 17, 2, 18, 12, 19, 35, 20, 35
        ],
        "line-blur": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.45, 14, 0.25, 18, 0.05, 20, 0
        ],
        "line-opacity": [
          "interpolate", ["linear"], ["zoom"],
          7, 1
        ]
      },
    },

    // Roads Secondary - Center (Z7+)
    {
      id: "roads_secondary",
      type: "line",
      source: "tegola",
      "source-layer": "roads_secondary",
      minzoom: 7,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "secondary"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#A9B8C8",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          7, 0.5, 8, 0.5, 9, 0.5, 10, 1, 11, 1, 12, 2, 13, 2, 14, 4, 15, 6, 16, 8, 17, 10, 18, 20, 19, 50, 20, 50
        ],
        "line-blur": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.45, 14, 0.25, 18, 0.05, 20, 0
        ],
        "line-opacity": [
          "interpolate", ["linear"], ["zoom"],
          7, 1
        ]
      },
    },

    // Roads Primary Link - Center (Z12+)
    {
      id: "roads_primary_link",
      type: "line",
      source: "tegola",
      "source-layer": "roads_primary",
      minzoom: 12,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "primary_link"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#A9B8C8",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          12, 0.5, 13, 1, 14, 2, 15, 3, 16, 4, 17, 6, 18, 16, 19, 40, 20, 40
        ],
        "line-blur": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.45, 14, 0.25, 18, 0.05, 20, 0
        ],
        "line-opacity": [
          "interpolate", ["linear"], ["zoom"],
          7, 1
        ]
      },
    },

    // Roads Primary - Center (Z7+)
    {
      id: "roads_primary",
      type: "line",
      source: "tegola",
      "source-layer": "roads_primary",
      minzoom: 7,
      maxzoom: 20,
      filter: ["==", ["get", "class"], "primary"],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#A9B8C8",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          7, 0.5, 8, 0.5, 9, 0.5, 10, 1, 11, 1, 12, 2, 13, 2, 14, 4, 15, 6, 16, 8, 17, 10, 18, 20, 19, 50, 20, 50
        ],
        "line-blur": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.45, 14, 0.25, 18, 0.05, 20, 0
        ],
        "line-opacity": [
          "interpolate", ["linear"], ["zoom"],
          7, 1
        ]
      },
    },

    // Roads Motorway/Trunk Link - Center (Z7+)
    {
      id: "roads_mw_trunk_link",
      type: "line",
      source: "tegola",
      "source-layer": "roads_motorway",
      minzoom: 7,
      maxzoom: 20,
      filter: ["any",
        ["==", ["get", "class"], "motorway_link"],
        ["==", ["get", "class"], "trunk_link"]
      ],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#8AA4BE",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          7, 0.5, 8, 0.5, 9, 0.5, 10, 1, 11, 1, 12, 2, 13, 2, 14, 4, 15, 6, 16, 8, 17, 10, 18, 20, 19, 50, 20, 50
        ],
        "line-opacity": 1
      },
    },

    // Roads Motorway/Trunk - Center (Z5+)
    {
      id: "roads_motorway",
      type: "line",
      source: "tegola",
      "source-layer": "roads_motorway",
      minzoom: 5,
      maxzoom: 20,
      filter: ["any",
        ["==", ["get", "class"], "motorway"],
        ["==", ["get", "class"], "trunk"]
      ],
      layout: { "line-cap": "round", "line-join": "round", "line-miter-limit": 2, "line-round-limit": 1.05 },
      paint: {
        "line-color": "#8AA4BE",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          5, 0.25, 6, 0.5, 7, 1, 8, 1, 9, 2, 10, 2, 11, 4, 12, 4, 13, 4, 14, 10, 15, 12, 16, 14, 17, 20, 18, 30, 19, 70, 20, 70
        ],
        "line-opacity": 1
      },
    },

    // Country and State Boundary outline (Z4+) - V3 dash style
    {
      id: "country_state_boundary_outline",
      type: "line",
      source: "tegola",
      "source-layer": "country_state_boundary",
      minzoom: 4,
      maxzoom: 20,
      layout: {
        "line-cap": "round",
        "line-join": "round"
      },
      paint: {
        "line-color": "#B3B2B2",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          4, 1,
          8, 1,
          12, 1,
          14, 1,
          18, 1
        ],
        "line-dasharray": [1, 6],
        "line-opacity": 1
      },
    },

    // Asian Country Boundaries outline (Z0+)
    {
      id: "asia_country_boundary_outline",
      type: "line",
      source: "tegola",
      "source-layer": "asia_country_boundary",
      minzoom: 0,
      maxzoom: 20,
      layout: {
        "line-cap": "round",
        "line-join": "round"
      },
      paint: {
        "line-color": "#000000",
        "line-width": [
          "interpolate", ["linear"], ["zoom"],
          0, 0.3,
          4, 0.6,
          8, 1.5,
          12, 2,
          14, 2.5,
          18, 3
        ],
        "line-opacity": 1
      },
    },


    // ========================================================================
    // LAYER 3: SYMBOLS / LABELS (Top layer - always visible)
    // ========================================================================

    // ========================================================================
    // POI LAYERS — All reference the unified "poi_curated" source-layer.
    // The usePOI hook queries features via queryRenderedFeatures using the
    // layer IDs: pois_important, pois_amenity, pois_shop_tourism_leisure,
    // pois_natural_manmade. These layers render ALL poi_curated features as
    // invisible circles so they are queryable. The JS code in usePOI handles
    // the actual filtering by amenity type.
    // ========================================================================

    // POIs Important — early visibility from Z12 (hospitals, police, fuel, etc.)
    {
      id: "pois_important",
      type: "circle",
      source: "tegola",
      "source-layer": "poi_curated",
      minzoom: 12,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Amenity — all POIs from Z14
    {
      id: "pois_amenity",
      type: "circle",
      source: "tegola",
      "source-layer": "poi_curated",
      minzoom: 14,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Shop/Tourism/Leisure — all POIs from Z14
    {
      id: "pois_shop_tourism_leisure",
      type: "circle",
      source: "tegola",
      "source-layer": "poi_curated",
      minzoom: 14,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Natural/Manmade — all POIs from Z15
    {
      id: "pois_natural_manmade",
      type: "circle",
      source: "tegola",
      "source-layer": "poi_curated",
      minzoom: 15,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Service — ATMs, fuel, police etc. from separate source-layer (Z14+)
    {
      id: "pois_service_layer",
      type: "circle",
      source: "tegola",
      "source-layer": "pois_service",
      minzoom: 14,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Food — cafes, restaurants, fast_food from separate source-layer (Z14+)
    {
      id: "pois_food_layer",
      type: "circle",
      source: "tegola",
      "source-layer": "pois_food",
      minzoom: 14,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Shop — pharmacies, malls, marketplaces from separate source-layer (Z14+)
    {
      id: "pois_shop_layer",
      type: "circle",
      source: "tegola",
      "source-layer": "pois_shop",
      minzoom: 14,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Transport — fuel stations from separate source-layer (Z14+)
    {
      id: "pois_transport_layer",
      type: "circle",
      source: "tegola",
      "source-layer": "pois_transport",
      minzoom: 14,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Major — colleges, universities from separate source-layer (Z12+)
    {
      id: "pois_major_layer",
      type: "circle",
      source: "tegola",
      "source-layer": "pois_major",
      minzoom: 12,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // POIs Other — forts, castles, historic from separate source-layer (Z12+)
    {
      id: "pois_other_layer",
      type: "circle",
      source: "tegola",
      "source-layer": "pois_other",
      minzoom: 12,
      maxzoom: 20,
      paint: {
        "circle-radius": 1,
        "circle-opacity": 0.01,
        "circle-stroke-opacity": 0
      },
    },

    // Bus Stops — rendered as native icon layer, separate from POI system (Z15+)
    // NOTE: Layer is added dynamically in App.js after the icon image loads.

    // Metro Stations — rendered as native icon layer, separate from POI system (Z13+)
    // NOTE: Layer is added dynamically in App.js after the icon image loads
    // to avoid rendering issues with missing images.

    // Natural Peaks (Z9+)
    {
      id: "natural_peaks",
      type: "symbol",
      source: "tegola",
      "source-layer": "natural_peaks",
      minzoom: 9,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Italic"],
        "text-size": [
          "interpolate", ["linear"], ["zoom"],
          9, 7.2, 13, 8.8, 16, 10.4
        ],
        "text-padding": 10,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": "#666",
        "text-halo-color": "#fff",
        "text-halo-width": 1.5,
        "text-halo-blur": 0,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          9, 0, 10, 1
        ]
      },
    },

    // Natural Points (Z13+)
    {
      id: "natural_points",
      type: "symbol",
      source: "tegola",
      "source-layer": "natural_points",
      minzoom: 13,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Italic"],
        "text-size": [
          "interpolate", ["linear"], ["zoom"],
          13, 6.4, 17, 8, 19, 8.8, 20, 9.6
        ],
        "text-padding": 10,
        "text-max-width": 11,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": "#666",
        "text-halo-color": "#fff",
        "text-halo-width": 1.5,
        "text-halo-blur": 0,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          13, 0, 14, 1
        ]
      },
    },


    // ========================================================================
    // HIGHWAY SHIELDS - V3 styling (zoom-interpolated spacing/padding)
    // ========================================================================

    // National Highway Shields (NH) (Z7+)
    {
      id: "highway_shields_nh",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_motorway",
      minzoom: 7,
      maxzoom: 20,
      filter: ["all", ["has", "ref"], ["!", ["==", ["get", "ref"], ""]], ["in", "NH", ["get", "ref"]], [">", ["length", ["get", "ref"]], 2]],
      layout: {
        "visibility": "none",
        "text-field": ["slice", ["get", "ref"], 2],
        "text-font": ["Roboto Medium"],
        "text-size": 11.2,
        "text-line-height": 1.3333,
        "text-justify": "center",
        "text-letter-spacing": 0.05,
        "icon-image": "square_11",
        "icon-size": 2.4,
        "icon-text-fit": "none",
        "symbol-placement": "line",
        "symbol-avoid-edges": true,
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          7, 600,
          10, 1800,
          13, 2000,
          16, 2200,
          18, 2500,
          20, 3500
        ],
        "text-padding": [
          "interpolate", ["linear"], ["zoom"],
          7, 40,
          10, 150,
          13, 100,
          16, 130,
          18, 120,
          20, 160
        ],
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-allow-overlap": false
      },
      paint: {
        "text-color": "#2B2B2B",
        "icon-color": "#FDD835",
        "icon-opacity": 1,
        "text-opacity": 1
      },
    },

    // State Highway Shields (SH) - Green badges (Z10+)
    {
      id: "highway_shields_sh",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_primary",
      minzoom: 10,
      maxzoom: 20,
      filter: ["all", ["has", "ref"], ["!", ["==", ["get", "ref"], ""]], ["in", "SH", ["get", "ref"]], [">", ["length", ["get", "ref"]], 2]],
      layout: {
        "visibility": "none",
        "text-field": [
          "case",
          ["==", ["slice", ["get", "ref"], 2, 3], " "],
          ["slice", ["get", "ref"], 3],
          ["slice", ["get", "ref"], 2]
        ],
        "text-font": ["Roboto Medium"],
        "text-size": 9.6,
        "text-letter-spacing": 0.05,
        "icon-image": "square_11",
        "icon-size": 2.4,
        "icon-text-fit": "none",
        "symbol-placement": "line",
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          10, 350,
          12, 500,
          14, 700,
          16, 950,
          18, 1200,
          20, 1400
        ],
        "text-padding": [
          "interpolate", ["linear"], ["zoom"],
          10, 35,
          12, 40,
          14, 45,
          16, 50,
          18, 55,
          20, 60
        ],
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-allow-overlap": false
      },
      paint: {
        "text-color": "#FFFFFF",
        "icon-color": "#2E7D32",
        "icon-opacity": 1,
        "text-opacity": 1
      },
    },

    // District Road Shields (MDR) from roads_primary (Z11+)
    {
      id: "highway_shields_mdr",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_primary",
      minzoom: 11,
      maxzoom: 20,
      filter: ["all", ["has", "ref"], ["!", ["==", ["get", "ref"], ""]], ["any", ["in", "MDR", ["get", "ref"]], ["in", "MD", ["get", "ref"]]], ["any", ["all", ["in", "MDR", ["get", "ref"]], [">", ["length", ["get", "ref"]], 3]], ["all", ["!", ["in", "MDR", ["get", "ref"]]], ["in", "MD", ["get", "ref"]], [">", ["length", ["get", "ref"]], 2]]]],
      layout: {
        "visibility": "none",
        "text-field": [
          "case",
          ["==", ["slice", ["get", "ref"], 0, 3], "MDR"],
          ["case",
            ["==", ["slice", ["get", "ref"], 3, 4], " "],
            ["slice", ["get", "ref"], 4],
            ["slice", ["get", "ref"], 3]
          ],
          ["case",
            ["==", ["slice", ["get", "ref"], 2, 3], " "],
            ["slice", ["get", "ref"], 3],
            ["slice", ["get", "ref"], 2]
          ]
        ],
        "text-font": ["Roboto Medium"],
        "text-size": 9.6,
        "text-letter-spacing": 0.05,
        "icon-image": "square_11",
        "icon-size": 2.4,
        "icon-text-fit": "none",
        "symbol-placement": "line",
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          11, 400,
          13, 600,
          15, 900,
          17, 1300,
          19, 1600,
          20, 1800
        ],
        "text-padding": [
          "interpolate", ["linear"], ["zoom"],
          11, 30,
          13, 35,
          15, 40,
          17, 45,
          19, 50,
          20, 55
        ],
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-allow-overlap": false
      },
      paint: {
        "text-color": "#454545",
        "icon-color": "#FFFFFF",
        "icon-opacity": 1,
        "text-opacity": 1
      },
    },

    // District Road Shields (MDR) from roads_secondary (Z11+)
    {
      id: "highway_shields_mdr_secondary",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_secondary",
      minzoom: 11,
      maxzoom: 20,
      filter: ["all", ["has", "ref"], ["!", ["==", ["get", "ref"], ""]], ["any", ["in", "MDR", ["get", "ref"]], ["in", "MD", ["get", "ref"]]], ["any", ["all", ["in", "MDR", ["get", "ref"]], [">", ["length", ["get", "ref"]], 3]], ["all", ["!", ["in", "MDR", ["get", "ref"]]], ["in", "MD", ["get", "ref"]], [">", ["length", ["get", "ref"]], 2]]]],
      layout: {
        "visibility": "none",
        "text-field": [
          "case",
          ["==", ["slice", ["get", "ref"], 0, 3], "MDR"],
          ["case",
            ["==", ["slice", ["get", "ref"], 3, 4], " "],
            ["slice", ["get", "ref"], 4],
            ["slice", ["get", "ref"], 3]
          ],
          ["case",
            ["==", ["slice", ["get", "ref"], 2, 3], " "],
            ["slice", ["get", "ref"], 3],
            ["slice", ["get", "ref"], 2]
          ]
        ],
        "text-font": ["Roboto Medium"],
        "text-size": 9.6,
        "text-letter-spacing": 0.05,
        "icon-image": "square_11",
        "icon-size": 2.4,
        "icon-text-fit": "none",
        "symbol-placement": "line",
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          11, 450,
          13, 650,
          15, 950,
          17, 1350,
          19, 1700,
          20, 1900
        ],
        "text-padding": [
          "interpolate", ["linear"], ["zoom"],
          11, 35,
          13, 40,
          15, 45,
          17, 50,
          19, 55,
          20, 60
        ],
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-allow-overlap": false
      },
      paint: {
        "text-color": "#454545",
        "icon-color": "#FFFFFF",
        "icon-opacity": 1,
        "text-opacity": 1
      },
    },

    // North-East Highway Shields (NE) (Z7+)
    {
      id: "highway_shields_ne",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_motorway",
      minzoom: 7,
      maxzoom: 20,
      filter: ["all", ["has", "ref"], ["!", ["==", ["get", "ref"], ""]], ["in", "NE", ["get", "ref"]], [">", ["length", ["get", "ref"]], 2]],
      layout: {
        "visibility": "none",
        "text-field": ["get", "ref"],
        "text-font": ["Roboto Medium"],
        "text-size": 10.4,
        "text-letter-spacing": 0.05,
        "symbol-placement": "line",
        "symbol-avoid-edges": true,
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          7, 600,
          10, 1800,
          13, 2000,
          16, 2200,
          18, 2500,
          20, 3500
        ],
        "text-padding": [
          "interpolate", ["linear"], ["zoom"],
          7, 40,
          10, 150,
          13, 100,
          16, 130,
          18, 120,
          20, 160
        ],
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-allow-overlap": false,
        "icon-image": "square_11",
        "icon-size": 2.4,
        "icon-text-fit": "none"
      },
      paint: {
        "text-color": "#2B2B2B",
        "icon-color": "#FDD835",
        "icon-opacity": 1,
        "text-opacity": 1
      },
    },

    // Motorway/Expressway Shields (Z7+)
    {
      id: "highway_shields_expressway",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_motorway",
      minzoom: 7,
      maxzoom: 20,
      filter: ["all", ["has", "ref"], ["!", ["==", ["get", "ref"], ""]], ["!", ["in", "NH", ["get", "ref"]]], ["!", ["in", "NE", ["get", "ref"]]], ["==", ["get", "class"], "motorway"]],
      layout: {
        "visibility": "none",
        "text-field": ["get", "ref"],
        "text-font": ["Roboto Medium"],
        "text-size": 10.4,
        "text-letter-spacing": 0.05,
        "icon-image": "square_11",
        "icon-size": 2.4,
        "icon-text-fit": "none",
        "symbol-placement": "line",
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          7, 600,
          10, 1800,
          13, 2000,
          16, 2200,
          18, 2500,
          20, 3500
        ],
        "text-padding": [
          "interpolate", ["linear"], ["zoom"],
          7, 40,
          10, 150,
          13, 100,
          16, 130,
          18, 120,
          20, 160
        ],
        "text-rotation-alignment": "viewport",
        "text-pitch-alignment": "viewport",
        "text-allow-overlap": false
      },
      paint: {
        "text-color": "#2B2B2B",
        "icon-color": "#FDD835",
        "icon-opacity": 1,
        "text-opacity": 1
      },
    },


    // ========================================================================
    // ROAD LABELS - V3 styling (color inversion at high zoom)
    // ========================================================================

    // Road labels - Motorway (Z13.5+)
    {
      id: "roads_motorway_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_motorway",
      minzoom: 13.5,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": [
          "step", ["zoom"],
          ["literal", ["Noto Sans Bold"]],
          19.75, ["literal", ["Noto Sans Bold"]]
        ],
        "text-size": [
          "step", ["zoom"],
          12,
          17, 16,
          18, 18,
          19, 20
        ],
        "text-letter-spacing": [
          "interpolate", ["linear"], ["zoom"],
          13.5, 0.064,
          17, 0.05,
          18, 0.07,
          19, 0.04
        ],
        "symbol-placement": "line",
        "text-rotation-alignment": "map",
        "text-max-angle": 30,
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          13.5, 300,
          16, 500,
          18, 600,
          20, 1000
        ],
        "text-padding": 1.5,
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "symbol-avoid-edges": false
      },
      paint: {
        "text-color": [
          "step", ["zoom"],
          "#343C51",
          17, "#FFFFFF"
        ],
        "text-halo-color": [
          "step", ["zoom"],
          "#FFFFFF",
          17, "#5A688C"
        ],
        "text-halo-width": [
          "step", ["zoom"],
          1.2,
          18, 1,
          19, 1.2
        ],
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Road labels - Primary (Z14.5+)
    {
      id: "roads_primary_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_primary",
      minzoom: 14.5,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": [
          "step", ["zoom"],
          ["literal", ["Noto Sans Bold"]],
          19, ["literal", ["Noto Sans Bold"]]
        ],
        "text-size": [
          "step", ["zoom"],
          10,
          15, 12,
          18, 16,
          19, 18
        ],
        "text-letter-spacing": [
          "step", ["zoom"],
          0.1,
          19, 0.05
        ],
        "symbol-placement": "line",
        "text-rotation-alignment": "map",
        "text-max-angle": 30,
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          14.5, 350,
          16, 450,
          18, 550,
          20, 650
        ],
        "text-padding": 1.5,
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "symbol-avoid-edges": false
      },
      paint: {
        "text-color": [
          "step", ["zoom"],
          "#343C51",
          18, "#FFFFFF"
        ],
        "text-halo-color": [
          "step", ["zoom"],
          "#FFFFFF",
          18, "#64739B"
        ],
        "text-halo-width": [
          "step", ["zoom"],
          1,
          18, 1,
          19, 1.2
        ],
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Road labels - Secondary (Z15+)
    {
      id: "roads_secondary_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_secondary",
      minzoom: 15,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Bold"],
        "text-size": [
          "step", ["zoom"],
          10,
          16, 11,
          17, 12,
          18, 14,
          18.5, 16
        ],
        "text-letter-spacing": [
          "step", ["zoom"],
          0.03,
          18, 0.05
        ],
        "symbol-placement": "line",
        "text-rotation-alignment": "map",
        "text-max-angle": 30,
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          15, 300,
          16, 350,
          18, 400,
          20, 600
        ],
        "text-padding": 1.5,
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "symbol-avoid-edges": false
      },
      paint: {
        "text-color": [
          "step", ["zoom"],
          "#404040",
          18, "#FFFFFF"
        ],
        "text-halo-color": [
          "step", ["zoom"],
          "#FFFFFF",
          18, "#2B2B2B"
        ],
        "text-halo-width": [
          "step", ["zoom"],
          1,
          18, 0.7
        ],
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Road labels - Minor Tertiary (Z15.5+)
    {
      id: "roads_minor_tertiary_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_minor",
      minzoom: 15.5,
      maxzoom: 20,
      filter: ["all", ["!", ["==", ["get", "name"], ""]], ["==", ["get", "class"], "tertiary"]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Bold"],
        "text-size": [
          "step", ["zoom"],
          10,
          18, 14,
          18.4, 16
        ],
        "text-letter-spacing": [
          "step", ["zoom"],
          0.03,
          18, 0.1,
          18.4, 0.05
        ],
        "symbol-placement": "line",
        "text-rotation-alignment": "map",
        "text-max-angle": 30,
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          15.5, 100,
          16, 350,
          18, 450,
          20, 600
        ],
        "text-padding": 1.5,
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "symbol-avoid-edges": false
      },
      paint: {
        "text-color": [
          "step", ["zoom"],
          "#404040",
          18, "#FFFFFF"
        ],
        "text-halo-color": [
          "step", ["zoom"],
          "#FFFFFF",
          18, "#3B3B3B"
        ],
        "text-halo-width": [
          "step", ["zoom"],
          1,
          18, 0.8
        ],
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Road labels - Minor Residential (Z18+)
    {
      id: "roads_minor_residential_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_minor",
      minzoom: 18,
      maxzoom: 20,
      filter: ["all", ["!", ["==", ["get", "name"], ""]], ["!=", ["get", "class"], "tertiary"]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Bold"],
        "text-size": [
          "step", ["zoom"],
          12,
          19, 16
        ],
        "text-letter-spacing": 0.1,
        "symbol-placement": "line",
        "text-rotation-alignment": "map",
        "text-max-angle": 30,
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          18, 500,
          19, 600,
          20, 700
        ],
        "text-padding": 1.5,
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "symbol-avoid-edges": false
      },
      paint: {
        "text-color": [
          "step", ["zoom"],
          "#343C51",
          19, "#FFFFFF"
        ],
        "text-halo-color": [
          "step", ["zoom"],
          "#FFFFFF",
          19, "#3B3B3B"
        ],
        "text-halo-width": 1,
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Road labels - Service (Z18.5+)
    {
      id: "roads_service_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "roads_service",
      minzoom: 18.5,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Bold"],
        "text-size": [
          "step", ["zoom"],
          10,
          19, 12
        ],
        "text-letter-spacing": [
          "step", ["zoom"],
          0.05,
          19, 0.1
        ],
        "symbol-placement": "line",
        "text-rotation-alignment": "map",
        "text-max-angle": 30,
        "symbol-spacing": [
          "interpolate", ["linear"], ["zoom"],
          18.5, 300,
          19, 500,
          20, 600
        ],
        "text-padding": 1.5,
        "text-optional": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "symbol-avoid-edges": false
      },
      paint: {
        "text-color": [
          "step", ["zoom"],
          "#343C51",
          19, "#FFFFFF"
        ],
        "text-halo-color": [
          "step", ["zoom"],
          "#FFFFFF",
          19, "#535353"
        ],
        "text-halo-width": [
          "step", ["zoom"],
          0.7,
          19, 1
        ],
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },


    // ========================================================================
    // LAYER 4: POLYGON LABELS
    // ========================================================================

    // Water Polygon Low - Labels (Z5-8)
    {
      id: "water_polygon_low_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "water_polygon_low",
      minzoom: 5,
      maxzoom: 8,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": 14,
        "text-line-height": 1.43,
        "text-letter-spacing": 0.018,
        "text-padding": 8,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": "#00879D",
        "text-halo-color": "rgba(255, 255, 255, 0)",
        "text-halo-width": 0,
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Water Polygon Mid - Labels (Z8-13)
    {
      id: "water_polygon_mid_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "water_polygon_mid",
      minzoom: 8,
      maxzoom: 13,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": 14,
        "text-line-height": 1.43,
        "text-letter-spacing": 0.018,
        "symbol-placement": "point",
        "text-padding": 80,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": true
      },
      paint: {
        "text-color": "#00879D",
        "text-halo-color": "rgba(255, 255, 255, 0)",
        "text-halo-width": 0,
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Water Polygon High - Labels (Z13.5+)
    {
      id: "water_polygon_high_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "water_polygon_high",
      minzoom: 13.5,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": 14,
        "text-line-height": 1.43,
        "text-letter-spacing": 0.018,
        "text-padding": 80,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": "#00879D",
        "text-halo-color": "rgba(255, 255, 255, 0)",
        "text-halo-width": 0,
        "text-halo-blur": 0,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          13.5, 0, 14, 1
        ]
      },
    },

    // Landcover High - Labels (Z14+)
    {
      id: "landcover_high_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "landcover_high",
      minzoom: 14,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": 14,
        "text-line-height": 1.43,
        "text-letter-spacing": 0.018,
        "text-padding": 10,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": "#42a85d",
        "text-halo-color": "rgba(255, 255, 255, 0)",
        "text-halo-width": 0,
        "text-halo-blur": 0,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          14, 0, 14.5, 1
        ]
      },
    },

    // Landuse Agricultural - Labels (Z11+)
    {
      id: "landuse_agricultural_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "landuse_agricultural",
      minzoom: 11,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": 14,
        "text-line-height": 1.43,
        "text-letter-spacing": 0.018,
        "text-padding": 10,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": "#42a85d",
        "text-halo-color": "rgba(255, 255, 255, 0)",
        "text-halo-width": 0,
        "text-halo-blur": 0,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          11, 0, 11.5, 1
        ]
      },
    },

    // Leisure - Labels (Z14+)
    {
      id: "leisure_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "leisure",
      minzoom: 14,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": 14,
        "text-line-height": 1.43,
        "text-letter-spacing": 0.018,
        "text-padding": 10,
        "text-allow-overlap": false,
        "text-ignore-placement": false
      },
      paint: {
        "text-color": "#42a85d",
        "text-halo-color": "rgba(255, 255, 255, 0)",
        "text-halo-width": 0,
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Buildings - Labels (Z16+)
    {
      id: "buildings_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "buildings",
      minzoom: 16,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "visibility": "none",
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Regular"],
        "text-size": [
          "interpolate", ["linear"], ["zoom"],
          16, 7.2, 17, 8.8, 20, 10.4
        ],
        "text-padding": 25,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": true,
        "symbol-avoid-edges": true
      },
      paint: {
        "text-color": "#555",
        "text-halo-color": "#FFFFFF",
        "text-halo-width": 1.5,
        "text-halo-blur": 0,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          16, 0, 16.5, 1
        ]
      },
    },

    // Aeroway Polygon - Labels with Airport Icon (Z10+)
    // NOTE: Airport labels are deduplicated in App.js (airports_dedupe layer).
    // This static layer is hidden; the dynamic layer handles rendering.
    {
      id: "aeroway_polygon_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "aeroway_polygon",
      minzoom: 10,
      maxzoom: 20,
      filter: ["all", ["!", ["==", ["get", "name"], ""]], ["==", ["get", "class"], "aerodrome"]],
      layout: {
        "visibility": "none",
        "icon-image": "airport-pin-icon",
        "icon-size": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.6, 13, 0.8, 16, 1
        ],
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
        "icon-anchor": "bottom",
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Bold"],
        "text-size": [
          "interpolate", ["linear"], ["zoom"],
          10, 9, 13, 10, 16, 11.2, 19, 12.8
        ],
        "text-anchor": "left",
        "text-offset": [1, -1],
        "text-max-width": 10,
        "text-padding": 2,
        "text-allow-overlap": false,
        "text-optional": true
      },
      paint: {
        "icon-opacity": 1,
        "text-color": "#4CAFBF",
        "text-halo-color": "#FFFFFF",
        "text-halo-width": 1.5,
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },


    // ========================================================================
    // COUNTRY & STATE LABELS
    // ========================================================================

    // Asian Country Labels (from asia_country_boundary tile layer) (Z2-10)
    {
      id: "asia_country_boundary_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "asia_country_boundary",
      minzoom: 2,
      maxzoom: 10,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Regular"],
        "text-size": [
          "interpolate", ["linear"], ["zoom"],
          2, 7.2, 4, 10.88, 6, 18.24, 8, 21.92, 10, 23.76
        ],
        "text-transform": "uppercase",
        "text-padding": 5,
        "text-letter-spacing": 0.15,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": true,
        "text-max-width": 10
      },
      paint: {
        "text-color": [
          "interpolate", ["linear"], ["zoom"],
          8, "#2a2a2a", 10, "#b0b0b0"
        ],
        "text-halo-color": "#ffffff",
        "text-halo-width": [
          "interpolate", ["linear"], ["zoom"],
          2, 1.5, 6, 2, 10, 2.2
        ],
        "text-halo-blur": 0.5,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          8, 1, 10, 0
        ]
      },
    },

    // Asia Water Body Labels (Z2-10)
    {
      id: "asia_water_boundary_labels",
      type: "symbol",
      source: "tegola",
      "source-layer": "asia_water_boundary",
      minzoom: 2,
      maxzoom: 10,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "visibility": "none",
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": 14,
        "text-line-height": 1.43,
        "text-transform": "uppercase",
        "text-padding": 5,
        "text-letter-spacing": 0.018,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": true,
        "text-max-width": 12
      },
      paint: {
        "text-color": "#00879D",
        "text-halo-color": "#ffffff",
        "text-halo-width": [
          "interpolate", ["linear"], ["zoom"],
          2, 1.5, 6, 2, 10, 2.2
        ],
        "text-halo-blur": 0.5,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          8, 1, 10, 0
        ]
      },
    },

    // Fallback country & water labels
    {
      id: "places_country_fallback",
      type: "symbol",
      source: "country_labels_fallback",
      minzoom: 2,
      maxzoom: 10,
      filter: ["all",
        ["any", ["!=", ["get", "name"], "Bangladesh"], [">=", ["zoom"], 6]],
        ["!", ["in", ["get", "name"], ["literal", ["Arabian Sea", "Bay of Bengal", "Indian Ocean", "South China Sea"]]]]
      ],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Regular"],
        "text-size": [
          "interpolate", ["linear"], ["zoom"],
          2, 7.2, 4, 10.88, 6, 18.24, 8, 21.92, 10, 23.76
        ],
        "text-transform": "uppercase",
        "text-padding": 5,
        "text-letter-spacing": 0.15,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": true,
        "text-max-width": 12
      },
      paint: {
        "text-color": [
          "interpolate", ["linear"], ["zoom"],
          8, "#2a2a2a", 10, "#b0b0b0"
        ],
        "text-halo-color": "#ffffff",
        "text-halo-width": [
          "interpolate", ["linear"], ["zoom"],
          2, 1.5, 6, 2, 10, 2.2
        ],
        "text-halo-blur": 0.5,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          8, 1, 10, 0
        ]
      },
    },

    // Water body labels (Arabian Sea, Bay of Bengal, etc.)
    {
      id: "places_water_fallback",
      type: "symbol",
      source: "country_labels_fallback",
      minzoom: 2,
      maxzoom: 10,
      filter: ["in", ["get", "name"], ["literal", ["Arabian Sea", "Bay of Bengal", "Indian Ocean", "South China Sea"]]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": 14,
        "text-line-height": 1.43,
        "text-transform": "uppercase",
        "text-padding": 5,
        "text-letter-spacing": 0.018,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": true,
        "text-max-width": 12
      },
      paint: {
        "text-color": "#00879D",
        "text-halo-color": "rgba(255, 255, 255, 0)",
        "text-halo-width": 0,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          8, 1, 10, 0
        ]
      },
    },

    // ========================================================================
    // Place State (Z4-11) - V2 layer name, V3 styling
    {
      id: "place_state",
      type: "symbol",
      source: "tegola",
      "source-layer": "place_state",
      minzoom: 4,
      maxzoom: 9,
      filter: ["all",
        ["!", ["==", ["get", "name"], ""]],
        ["==", ["get", "class"], "state"],
        ["!=", ["get", "name"], "Sikkim"]
      ],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Bold"],
        "text-size": [
          "step", ["zoom"],
          12,
          6, 14
        ],
        "text-transform": "uppercase",
        "text-padding": 2,
        "text-letter-spacing": 0.063,
        "symbol-avoid-edges": true,
        "text-variable-anchor": ["center", "bottom", "top", "left", "right"],
        "text-radial-offset": 0.7,
        "text-justify": "auto",
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": true,
        "text-max-width": 8
      },
      paint: {
        "text-color": "#2B2B2B",
        "text-halo-color": "#ffffff",
        "text-halo-width": 1,
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },

    // Fallback state labels (Sikkim, Lakshadweep)
    {
      id: "places_country_state_fallback",
      type: "symbol",
      source: "state_labels_fallback",
      minzoom: 2,
      maxzoom: 9,
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Bold"],
        "text-size": [
          "step", ["zoom"],
          12,
          6, 14
        ],
        "text-transform": "uppercase",
        "text-padding": 2,
        "text-letter-spacing": 0.063,
        "symbol-avoid-edges": true,
        "text-variable-anchor": ["center", "bottom", "top", "left", "right"],
        "text-radial-offset": 0.7,
        "text-justify": "auto",
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": true,
        "text-max-width": 8
      },
      paint: {
        "text-color": "#2B2B2B",
        "text-halo-color": "#ffffff",
        "text-halo-width": 1,
        "text-halo-blur": 0,
        "text-opacity": 1
      },
    },


    // ========================================================================
    // LAYER 5: PLACE LABELS (Highest priority - rendered last)
    // V2 layer names (place_hamlet, place_village, place_town, place_city)
    // V3 styling (Roboto fonts, population-based filtering, variable anchors)
    // ========================================================================

    // Place Hamlet (Z13+)
    {
      id: "place_hamlet",
      type: "symbol",
      source: "tegola",
      "source-layer": "place_hamlet",
      minzoom: 13,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": [
          "step", ["zoom"],
          13,
          14, 14,
          15, 15,
          17, 16,
          20, 16
        ],
        "text-padding": [
          "step", ["zoom"],
          80,
          14, 60,
          15, 25,
          17, 6,
          20, 3
        ],
        "symbol-sort-key": [
          "coalesce",
          ["index-of",
            ["downcase", ["slice", ["get", "name"], 0, 1]],
            "abcdefghijklmnopqrstuvwxyz"
          ],
          26
        ],
        "text-optional": false,
        "symbol-avoid-edges": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-variable-anchor": ["center", "bottom", "top", "left", "right"],
        "text-radial-offset": 0.7,
        "text-justify": "auto"
      },
      paint: {
        "text-color": "#222222",
        "text-halo-color": "#ffffff",
        "text-halo-width": [
          "interpolate", ["linear"], ["zoom"],
          13, 1.4, 14, 1.5, 17, 2, 19, 2.2, 20, 2.4
        ],
        "text-halo-blur": 0.5,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          13, 0.7, 14, 0.85, 15, 0.95, 16, 1, 20, 1
        ]
      },
    },

    // Place Village (Z10+)
    {
      id: "place_village",
      type: "symbol",
      source: "tegola",
      "source-layer": "place_village",
      minzoom: 10,
      maxzoom: 20,
      filter: ["!", ["==", ["get", "name"], ""]],
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": [
          "step", ["zoom"],
          13,
          11, 14,
          12, 15,
          13, 16,
          15, 16,
          20, 16
        ],
        "text-padding": [
          "step", ["zoom"],
          80,
          11, 60,
          12, 50,
          13, 25,
          14, 15,
          15, 10,
          17, 6,
          20, 3
        ],
        "symbol-sort-key": [
          "coalesce",
          ["index-of",
            ["downcase", ["slice", ["get", "name"], 0, 1]],
            "abcdefghijklmnopqrstuvwxyz"
          ],
          26
        ],
        "text-optional": false,
        "symbol-avoid-edges": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-variable-anchor": ["center", "bottom", "top", "left", "right"],
        "text-radial-offset": 0.7,
        "text-justify": "auto"
      },
      paint: {
        "text-color": "#222222",
        "text-halo-color": "#ffffff",
        "text-halo-width": [
          "interpolate", ["linear"], ["zoom"],
          10, 1.4, 11, 1.5, 14, 1.8, 17, 2, 19, 2.2, 20, 2.4
        ],
        "text-halo-blur": 0.5,
        "text-opacity": [
          "interpolate", ["linear"], ["zoom"],
          10, 0.7, 11, 0.85, 12, 0.95, 13, 1, 20, 1
        ]
      },
    },

    // Place Town (Z8+)
    {
      id: "place_town",
      type: "symbol",
      source: "tegola",
      "source-layer": "place_town",
      minzoom: 8,
      maxzoom: 20,
      filter: [
        "all",
        ["!", ["==", ["get", "name"], ""]],
        ["step", ["zoom"],
          ["any",
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 50000],
            ["==", ["get", "place"], "town"]
          ],
          9, ["any",
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 20000],
            ["==", ["get", "place"], "town"]
          ],
          10, ["any",
            [">", ["coalesce", ["to-number", ["get", "population"]], 0], 0],
            ["==", ["get", "place"], "town"]
          ],
          11, true
        ]
      ],
      layout: {
        "icon-image": ["step", ["zoom"], "crosshair-icon", 10, ""],
        "icon-size": 0.25,
        "icon-anchor": "center",
        "icon-pitch-alignment": "map",
        "icon-rotation-alignment": "map",
        "text-field": ["get", "name"],
        "text-font": ["Roboto Regular"],
        "text-size": [
          "interpolate", ["linear"], ["zoom"],
          8, 11.52, 10, 12.96, 12, 14.4, 14, 16.32, 17, 18, 20, 19.2
        ],
        "symbol-sort-key": [
          "-", 0, ["coalesce", ["to-number", ["get", "population"]], 0]
        ],
        "text-padding": [
          "interpolate", ["linear"], ["zoom"],
          8, 12, 10, 8, 12, 5, 14, 3, 16, 3, 18, 4, 20, 5
        ],
        "text-letter-spacing": 0.05,
        "text-max-width": 10,
        "text-transform": "none",
        "symbol-avoid-edges": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": false,
        "text-anchor": "left",
        "text-offset": ["step", ["zoom"], ["literal", [0.4, 0]], 10, ["literal", [0, 0]]],
        "text-justify": "left"
      },
      paint: {
        "text-color": "#222222",
        "text-halo-color": "#ffffff",
        "text-halo-width": [
          "interpolate", ["linear"], ["zoom"],
          8, 1.8, 10, 2, 14, 2.5, 18, 2.8, 20, 3
        ],
        "text-halo-blur": 0.5,
        "text-opacity": 1,
        "icon-opacity": [
          "step", ["zoom"],
          1,
          10, 0
        ]
      },
    },

    // Place City (Z5+) - Highest priority, V3 styling with population/capital filtering
    {
      id: "place_city",
      type: "symbol",
      source: "tegola",
      "source-layer": "place_city",
      minzoom: 5,
      maxzoom: 20,
      filter: [
        "all",
        ["!", ["==", ["get", "name"], ""]],
        ["step", ["zoom"],
          ["any",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]],
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000]
          ],
          6, ["any",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "5", "yes"]]],
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000],
            ["==", ["get", "place"], "city"]
          ],
          7, ["any",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "5", "yes"]]],
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 200000],
            ["==", ["get", "place"], "city"]
          ],
          8, ["any",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "5", "6", "yes"]]],
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 100000],
            ["==", ["get", "place"], "city"]
          ],
          9, ["any",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "5", "6", "yes"]]],
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 50000],
            ["==", ["get", "place"], "city"]
          ],
          10, ["any",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "5", "6", "yes"]]],
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 20000],
            ["==", ["get", "place"], "city"]
          ],
          11, ["any",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "5", "6", "yes"]]],
            [">", ["coalesce", ["to-number", ["get", "population"]], 0], 0],
            ["==", ["get", "place"], "city"]
          ],
          12, true
        ]
      ],
      layout: {
        "icon-image": ["step", ["zoom"], "crosshair-icon", 10, ""],
        "icon-size": [
          "case",
          ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 0.5,
          0.375
        ],
        "icon-anchor": "center",
        "icon-pitch-alignment": "map",
        "icon-rotation-alignment": "map",
        "text-field": ["get", "name"],
        "text-font": [
          "case",
          ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]],
          ["literal", ["Roboto Bold"]],
          ["==", ["get", "capital"], "5"],
          ["literal", ["Roboto Bold"]],
          ["literal", ["Roboto Regular"]]
        ],
        "text-size": [
          "step", ["zoom"],
          ["case",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 16,
            ["==", ["get", "capital"], "5"], 12,
            ["in", ["get", "capital"], ["literal", ["6"]]], 10,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000], 12,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000], 12,
            10
          ],
          6, ["case",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 18,
            ["==", ["get", "capital"], "5"], 14,
            ["in", ["get", "capital"], ["literal", ["6"]]], 12,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000], 14,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000], 14,
            12
          ],
          7, ["case",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 20,
            ["==", ["get", "capital"], "5"], 16,
            ["in", ["get", "capital"], ["literal", ["6"]]], 14,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000], 16,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000], 16,
            14
          ],
          8, ["case",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 22,
            ["==", ["get", "capital"], "5"], 18,
            ["in", ["get", "capital"], ["literal", ["6"]]], 16,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000], 18,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000], 18,
            16
          ],
          11, ["case",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 24,
            ["==", ["get", "capital"], "5"], 20,
            ["in", ["get", "capital"], ["literal", ["6"]]], 18,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000], 20,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000], 20,
            18
          ],
          14, ["case",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 24,
            ["==", ["get", "capital"], "5"], 20,
            ["in", ["get", "capital"], ["literal", ["6"]]], 18,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000], 20,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000], 20,
            18
          ],
          17, ["case",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 24,
            ["==", ["get", "capital"], "5"], 20,
            ["in", ["get", "capital"], ["literal", ["6"]]], 18,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000], 20,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000], 20,
            18
          ],
          20, ["case",
            ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 24,
            ["==", ["get", "capital"], "5"], 20,
            ["in", ["get", "capital"], ["literal", ["6"]]], 18,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 1000000], 20,
            [">=", ["coalesce", ["to-number", ["get", "population"]], 0], 500000], 20,
            18
          ]
        ],
        "symbol-sort-key": [
          "-", 0, ["+",
            ["case",
              ["in", ["get", "capital"], ["literal", ["2", "yes"]]], 50000000,
              ["==", ["get", "capital"], "3"], 30000000,
              ["==", ["get", "capital"], "4"], 20000000,
              ["==", ["get", "capital"], "5"], 10000000,
              ["==", ["get", "capital"], "6"], 5000000,
              0
            ],
            ["case", ["==", ["get", "place"], "city"], 2000000, 500000],
            ["coalesce", ["to-number", ["get", "population"]], 0]
          ]
        ],
        "text-padding": [
          "interpolate", ["linear"], ["zoom"],
          5, 12, 6, 10, 7, 8, 8, 6, 9, 5, 10, 4, 11, 3, 12, 2, 14, 3, 16, 4, 18, 5, 20, 5
        ],
        "text-letter-spacing": 0.05,
        "text-max-width": 10,
        "text-transform": "none",
        "symbol-avoid-edges": true,
        "text-allow-overlap": false,
        "text-ignore-placement": false,
        "text-optional": false,
        "text-anchor": "left",
        "text-offset": ["step", ["zoom"], ["literal", [0.4, 0]], 10, ["literal", [0, 0]]],
        "text-justify": "left"
      },
      paint: {
        "text-color": [
          "case",
          ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], "#1a1a1a",
          "#222222"
        ],
        "text-halo-color": "#ffffff",
        "text-halo-width": [
          "case",
          ["in", ["get", "capital"], ["literal", ["2", "3", "4", "yes"]]], 1.5,
          1
        ],
        "text-halo-blur": 0,
        "text-opacity": 1,
        "icon-opacity": [
          "step", ["zoom"],
          1,
          10, 0
        ]
      },
    },
  ],
};

// Interactive layers for click events
export const interactiveVectorLayers = [
  "asia_country_boundary_fill",
  "asia_water_boundary",
  "buildings",
  "pois_important",
  "pois_amenity",
  "pois_shop_tourism_leisure",
  "pois_natural_manmade",
  "roads_motorway",
  "roads_primary",
  "roads_secondary",
  "roads_minor_tertiary",
  "roads_minor_residential",
  "roads_service",
  "place_city",
  "place_town",
  "place_village",
  "place_hamlet",
  "leisure",
];
